import React from 'react';
import PropTypes from 'prop-types';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsLinkLabel } from './ps-link-label/PsLinkLabel';
import { PsRoutes } from '../../../shared/routing/Routes';

export const MachineLabel = (
    {
        machine,
    },
) => {
    const [to, setTo] = React.useState(undefined);

    React.useEffect(() => {
        if ( machine ) {
            const origin = machine.origin();
            const routeParams = {};
            const route = origin.isFromMyContractors()
                ? PsRoutes.MY_CONTRACTORS_MACHINES_DETAIL
                : PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL;

            if ( origin.hasCompany() ) {
                routeParams.outsourceId = origin.companyId();
            }

            if ( origin.hasMachine() ) {
                routeParams.machineId = origin.machineId();
            }

            const nextTo = RouterUtils.generateRoute(route, routeParams);
            const isWrong = nextTo.includes('undefined');

            if ( !isWrong ) {
                setTo(nextTo);
            }
        }
    }, [machine]);

    if ( !machine ) {
        return null;
    }

    const machineName = machine.name();

    return (
        <PsLinkLabel
            to={to}
            label={machineName}
        />
    );
};

MachineLabel.propTypes = {
    machine: PropTypes.object,
};

MachineLabel.defaultProps = {
    machine: null,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/components/MachineLabel.jsx